import { ComponentProps, FC } from 'react';
import { getTokenLogoURLs } from '../../../util/logos/get-token-logo-urls';
import { ChecksumAddress, ProtocolInstance } from '@silo/types';
import { Logo } from '@silo/ui';

interface AssetLogoProps {
  protocolInstance: ProtocolInstance;
  address: ChecksumAddress;
  size: AssetLogoSize;
}

type AssetLogoSize = ComponentProps<typeof Logo>['size'];

export const AssetLogo: FC<AssetLogoProps> = ({ protocolInstance, address, size }) => {
  const srcs = getTokenLogoURLs(address, protocolInstance);

  return <Logo srcs={srcs} size={size} />;
};
